import axios from 'axios';

export default {
    state: {
        meters: [],
        indicators: [],
        loading: false,
        total: 0,
        refresh: false,
    },
    getters: {
        meters: (state) => {
          return state.meters;
        },
      },
    mutations: {
        SET_METERS(state, meters) {
            state.meters = meters;
        },
        SET_INDICATORS(state, indicators) {
            state.indicators = indicators;
        },
        SET_TOTAL(state, total) {
            state.total = total;
        },
        SET_LOADING(state, val) {
            state.loading = val;
        },
        SET_REFRESH(state, val) {
            state.refresh = val;
        }
    },
    actions: {
        getAllMetters({ commit }, params) {
            commit('SET_LOADING', true);
            axios.get('/api/meter/all', { params }).then( response => {
                commit('SET_METERS', response.data);
                commit('SET_LOADING', false);
            }, error => {
                console.log(error);
                commit('SET_LOADING', false);
            })
        },
        getIndicatorsHistory({ commit }, params) {
            commit('SET_LOADING', true);
            axios.get('api/indicator/history', {
                params
            }).then( response => {
                commit('SET_INDICATORS', response.data.indicators);
                commit('SET_TOTAL', response.data.total);
                commit('SET_LOADING', false);
            }, error => {
                console.log(error);
                commit('SET_LOADING', false);
            })
        },
         // eslint-disable-next-line
         saveMeter({ }, data) {
            return new Promise((resolve, reject) => {
                axios({ url: '/api/meter/add', data, method: 'POST' })
                  .then((resp) => {
                    resolve(resp);
                  })
                  .catch((err) => {
                    reject(err);
                  });
              });
        },
         // eslint-disable-next-line
         saveIndicator({ }, data) {
            return new Promise((resolve, reject) => {
                axios({ url: '/api/indicator/add', data, method: 'POST' })
                  .then((resp) => {
                    resolve(resp);
                  })
                  .catch((err) => {
                    reject(err);
                  });
              });
        },
        setRefresh({ commit }, value) {
            commit('SET_REFRESH', value)
        },
        // eslint-disable-next-line
        deleteMeter({ }, data) {
            return new Promise((resolve, reject) => {
                axios({ url: '/api/meter/delete', data, method: 'POST' })
                  .then((resp) => {
                    resolve(resp);
                  })
                  .catch((err) => {
                    reject(err);
                  });
              });
        },
    }
}